var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityAssignment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#B2BEE0",
    strokeWidth: 2,
    fill: "#FFF",
    x: 1,
    y: 3.063,
    width: 14,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.858 4.716c-.04.05-.082.099-.127.144l-.028.028-.111.112-8.649 8.648a1.5 1.5 0 0 1-.696.387l-3.36.91a1.557 1.557 0 0 1-1.898-1.91l.906-3.342a1.54 1.54 0 0 1 .4-.699L14.91.4l.119-.133a.944.944 0 0 1 .13-.137l.175-.174A3.25 3.25 0 0 1 17.646-1c.867 0 1.708.335 2.33.956a3.283 3.283 0 0 1 0 4.642l-.118.118z",
    stroke: "#FFF",
    strokeWidth: 2,
    fill: "#B2BEE0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.442 1.85l1.64 1.64-8.55 8.567-1.64-1.622.017-.07z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityAssignment);
export default __webpack_public_path__ + "static/media/activity-assignment.cb61cc0d085cea3b269038dad19a6780.svg";
export { ForwardRef as ReactComponent };